import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suscripcion-beneficio-covid19-satisfactoria',
  templateUrl: './suscripcion-beneficio-covid19-satisfactoria.component.html',
  styleUrls: ['./suscripcion-beneficio-covid19-satisfactoria.component.scss']
})
export class SuscripcionBeneficioCovid19SatisfactoriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
